const filterRangeFields = document.querySelectorAll(".filter__price__range[data-range-filter-update]");
document.addEventListener("theme:range:updated", (e) => {
  return;
  const field = e.detail.target;
  if (!field) return;
  const minValue = field.dataset.seMinValue;
  const maxValue = field.dataset.seMaxValue;
  const minRange = field.dataset.seMin;
  const maxRange = field.dataset.seMax;
  const container = field.closest("[data-collapsible]");
  hideFilterBadge(container);
  if (minValue === minRange && maxValue === maxRange) return;
  showFilterBadge(minValue, maxValue, container);
});

function hideFilterBadge(container) {
  container.querySelector("[data-tag]")?.remove();
}

function showFilterBadge(min, max, container) {
  const header = container.querySelector(".filter-group__heading");
  const currencyContainer = container.querySelector(".filter__price__field span");

  const tag = document.createElement("span");

  tag.dataset.tag = "true";
  tag.innerText = `${currencyContainer.innerText}${min} - ${currencyContainer.innerText}${max}`;
  header.querySelector("div").appendChild(tag);
}
